import { setServiceDocuments } from '../../modules/entities/serviceDocuments/reducer';
import { logSentryError } from '../../sentry/sentry';
import { ApplicationState } from '../../types';

export const fetchServiceDocuments =
    ({ serviceIds, types }: $TSFixMe) =>
    async (dispatch: $TSFixMe, _getState: () => ApplicationState, { apiService }: $TSFixMe) => {
        try {
            const { documents } = await apiService.getServiceDocuments({ serviceIds, types });
            dispatch(setServiceDocuments({ serviceDocuments: documents }));
        } catch (error) {
            dispatch(logSentryError({ error, extra: { serviceIds, types } }));
        }
    };
